<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- <v-alert
    style="z-index: 999"
    :value="Alert.isShow"
    :type="Alert.type"
    :width="Alert.width"
    class="screen-center"
    transition="scale-transition"
    text
    >{{ Alert.msg }}</v-alert
  > -->
  <v-alert
    style="z-index: 999"
    :value="Alert.isShow"
    :width="Alert.width"
    class="screen-center"
    transition="scale-transition"
    :class="Alert.type"
    elevation="0"
    ><v-icon>{{ Alert.icon }}</v-icon> {{ Alert.msg }}</v-alert
  >
</template>
<style scoped>
.infoColor {
  background-color: #fdf6dd;
  border: #997a1d 1px solid;
}
.successColor {
  background-color: #e4fff3;
  border: #329667 1px solid;
}
.errorColor {
  background-color: #ffebe9;
  border: #c44e5a 1px solid;
}
</style>
>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      timer: null,
    };
  },
  computed: {
    ...mapState({
      Alert: "Alert",
    }),
  },
  methods: {
    hide_alert() {
      // console.log("Hide");
      clearInterval(this.timer);
      this.timer = window.setInterval(() => {
        this.Alert.isShow = false;
        // console.log("hide alert after 1 seconds");
        clearInterval(this.timer);
      }, 1500);
    },
  },
  watch: {
    "$store.state.Alert.clickTime": function () {
      this.hide_alert();
    },
  },
};
</script>
